import { render, staticRenderFns } from "./CommunicationItem.vue?vue&type=template&id=7da63532&scoped=true"
import script from "./CommunicationItem.vue?vue&type=script&lang=js"
export * from "./CommunicationItem.vue?vue&type=script&lang=js"
import style0 from "./CommunicationItem.vue?vue&type=style&index=0&id=7da63532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da63532",
  null
  
)

export default component.exports